<template>
	<div>
		<!-- 弹窗模式 -->
		<el-dialog v-if="dialogMode && showDialog" :visible.sync="showDialog" width="80%" title="门店加工订单详情" append-to-body :close-on-click-modal="false" @close="closeDialog" class="store-detail-dialog">
			<div class="dialog-body-compact">
				<detail :detail-row="detailRow" :detail-type="detailType" :is-show-warehouse-qty="false"></detail>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button v-if="$checkBtnPermission('/order/index', 'cancelOrder') && orderType === 1 && state != 6 && state != 10" size="small" type="danger" @click="handleCancelOrder">取消订单</el-button>
					<el-button v-if="$checkBtnPermission('/order/index', 'submit') && orderType === 1 && state === 2" size="small" type="danger" @click="handleSubmitOrder">提交订单</el-button>
					<el-button
						v-if="$checkBtnPermission('/order/index', 'submit') && orderType === 1 && state === 6 && (linkOrderKeyId === '' || linkOrderKeyId === null)"
						size="small"
						type="danger"
						@click="handleShowInnerDialog"
					>
						订单售后
					</el-button>
					<el-button size="small" @click="closeDialog">关闭</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 内联模式 -->
		<div v-if="!dialogMode && showDialog" class="inline-order-detail">
			<div class="inline-detail-header">
				<span class="inline-detail-title">门店加工订单详情</span>
				<el-button size="mini" icon="el-icon-close" @click="closeDialog">关闭</el-button>
			</div>
			<detail :detail-row="detailRow" :detail-type="detailType" :is-show-warehouse-qty="false"></detail>
			<div class="inline-detail-footer" v-if="showActions">
				<el-button v-if="$checkBtnPermission('/order/index', 'cancelOrder') && orderType === 1 && state != 6 && state != 10" size="small" type="danger" @click="handleCancelOrder">取消订单</el-button>
				<el-button v-if="$checkBtnPermission('/order/index', 'submit') && orderType === 1 && state === 2" size="small" type="danger" @click="handleSubmitOrder">提交订单</el-button>
				<el-button
					v-if="$checkBtnPermission('/order/index', 'submit') && orderType === 1 && state === 6 && (linkOrderKeyId === '' || linkOrderKeyId === null)"
					size="small"
					type="danger"
					@click="handleShowInnerDialog"
				>
					订单售后
				</el-button>
			</div>
		</div>

		<el-dialog :visible.sync="innerVisible" width="45%" title="订单售后" append-to-body :close-on-click-modal="false">
			售后原因:
			<el-input v-model="afterSaleReason" placeholder="请输入售后原因" size="small" type="text" maxlength="50" minlength="1" clearable show-word-limit></el-input>
			<template #footer>
				<div class="dialog-footer">
					<el-button size="small" @click="innerVisible = false">关闭</el-button>
					<el-button size="small" type="primary" @click="handleAfterSaleOrder">确认</el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script>
import { CancelStoreOrder, SubmitStoreOrder, CreateAfterSaleOrder } from "@/api/storeOrderApi.js";
import detail from "./detail.vue";
export default {
	props: {
		// 是否使用 el-dialog 弹窗模式（true=弹窗, false=列表下方内联展示）
		dialogMode: {
			type: Boolean,
			default: false
		},
		// 是否显示操作按钮（取消订单/提交订单/订单售后），顾客管理等纯查看场景传 false
		showActions: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			showDialog: false,
			keyId: "",
			state: 0,
			linkOrderKeyId: "",
			orderType: 1,
			innerVisible: false,
			afterSaleReason: "",
			currentRow: null,
			detailRow: null,
			detailType: 1
		};
	},
	computed: {},
	components: {
		detail
	},
	created() {},
	methods: {
		// 显示
		showSeeDetailDialog(row, type = 1) {
			this.state = row.state;
			this.linkOrderKeyId = row.linkOrderKeyId;
			this.orderType = type;
			this.afterSaleReason = "";
			this.keyId = row.keyId;
			this.detailType = type;
			this.showDialog = true;
			this.$nextTick(() => {
				this.detailRow = { ...row };
			});
		},
		// 关闭
		closeDialog() {
			this.showDialog = false;
		},
		// 取消订单
		handleCancelOrder() {
			this.$confirm("确定取消订单吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					// 调用取消订单接口
					CancelStoreOrder({
						keyId: this.keyId
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "取消订单成功"
								});
								this.closeDialog();
								this.$parent.getListData();
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch(() => {
							this.$message({
								type: "info",
								message: "已取消取消订单"
							});
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消取消订单"
					});
				});
		},
		// 提交订单
		handleSubmitOrder() {
			this.$confirm("确定提交订单吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					// 调用提交订单接口
					SubmitStoreOrder({
						keyId: this.keyId
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "提交订单成功"
								});
								this.closeDialog();
								this.$parent.getListData();
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch(() => {
							this.$message({
								type: "info",
								message: "已取消提交订单"
							});
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消提交订单"
					});
				});
		},
		// 创建售后订单
		handleAfterSaleOrder() {
			if (!this.afterSaleReason) {
				this.$message({
					type: "error",
					message: "请输入售后原因"
				});
				return;
			}
			this.$confirm("确定创建售后订单吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					// 调用订单售后接口
					CreateAfterSaleOrder({
						keyId: this.keyId,
						afterSaleReason: this.afterSaleReason
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "创建售后订单成功，售后订单号：" + res.data
								});
								this.afterSaleReason = "";
								this.innerVisible = false;
								this.closeDialog();
								this.$parent.getListData();
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch(() => {
							this.$message({
								type: "info",
								message: "已取消订单售后"
							});
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消订单售后"
					});
				});
		},
		// 显示售后订单弹窗
		handleShowInnerDialog() {
			this.innerVisible = true;
			this.afterSaleReason = "";
		}
	}
};
</script>
<style scoped lang="scss">
/* 弹窗模式下压缩 body 区域空白 */
.dialog-body-compact {
	margin: -10px 0 -15px 0;
}

.inline-order-detail {
	background: #fff;
	border: 1px solid #e7ebf3;
	border-radius: 12px;
	padding: 16px 20px;
	margin-top: 16px;
	box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05);
}

.inline-detail-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 12px;
	padding-bottom: 10px;
	border-bottom: 1px solid #f0f2f5;
}

.inline-detail-title {
	font-size: 16px;
	font-weight: 600;
	color: #1f2937;
}

.inline-detail-footer {
	display: flex;
	justify-content: flex-end;
	gap: 10px;
	margin-top: 16px;
	padding-top: 12px;
	border-top: 1px solid #f0f2f5;
}
</style>
